import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  insertTimeInfo,
  updateTimeInfo,
  deleteTimeInfo
} from "../../actions/action_timeInfo";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Typography from "@material-ui/core/Typography";

import { withSnackbar } from "notistack";

// icons
import TimeInfoIcon from "@material-ui/icons/Schedule";

import Switch from "@material-ui/core//Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// core components

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import api from "../../utils/api";
import { Link } from "react-router-dom";
import TextField from '@material-ui/core/TextField';

const intl = window.intl;
class TimeInfoEditPage extends React.Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location.search);
    this.state = {
      timeInfoID: props.match.params.timeInfoID,
      name: "",
      description: "",
      category: params.get("category"),
      hideCategory: params.has("category"),
      categories: [],
      active: true,
      timeInfoNotFound: false,
      error: {},
      mandatory: { name: true, description: true },
      modified: false
    };
  }
  getTimeInfo = async id => {
    const timeInfo = await api.get(`/timeInfos/${id}`);
    if (timeInfo && Object.keys(timeInfo).length > 0) {
      this.setState({ ...timeInfo, category:(timeInfo.category||{}).id, timeInfoNotFound: false });
    } else {
      this.setState({ timeInfoNotFound: true });
    }
  };
  getCategories = async id => {
    const categories = await api.get(`/modelSearch/categories`);
    this.setState({ categories });
  };

  componentDidMount() {
    const { timeInfoID } = this.state;
    timeInfoID && this.getTimeInfo(timeInfoID);
    this.getCategories();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data = {} } = nextProps.timeInfo || {};

    if (data.name !== this.state.name) {
      const {
        name,
        description,
        allow_attachments,
        allow_contact_persons
      } = data;
      this.setState({
        name,
        description,
        allow_attachments,
        allow_contact_persons
      });
    }
  }
  validateField = (name, value) => {
    const { error, mandatory } = this.state;
    if (mandatory[name]) {
      error[name] = value === undefined || value.length === 0;
    }
    this.setState({ error });
    return !error[name];
  };

  handleSwitchChange = name => event => {
    this.setState({ [name]: event.target.checked, modified: true });
  };
  handleTextChange = name => event => {
    this.validateField(name, event.target.value);
    this.setState({ [name]: event.target.value, modified: true });
  };
  onSubmit = () => {
    const {
      timeInfoID,
      name,
      description,
      category,
      active,
      modified,
      error = {}
    } = this.state;
    let valid = true;
    if (!modified) {
      this.props.enqueueSnackbar("No information is updated", {
        variant: "info"
      });
      return false;
    } else {
      valid = Object.keys(error).every(name => {
        return !error[name];
      });
    }
    if (!valid) {
      this.props.enqueueSnackbar("Please provide all required details", {
        variant: "error"
      });
      return false;
    }
    let data = {
      name,
      description,
      category,
      active
    };
    if (timeInfoID) {
      data.id = timeInfoID;
      this.props.updateTimeInfo(data, () => {
        this.props.enqueueSnackbar("TimeInfo updated successfully", {
          variant: "success"
        });
        this.props.history.goBack();
      });
    } else {
      this.props.insertTimeInfo(data, () => {
        this.props.enqueueSnackbar("TimeInfo saved successfully", {
          variant: "success"
        });
        this.props.history.goBack();
      });
    }
  };
  render() {
    const { classes } = this.props;
    const { timeInfoID, timeInfoNotFound, error = {}, modified, categories=[], category="", mandatory={} } = this.state;
    const hideCategory = category;
    return (
      <React.Fragment>
        {timeInfoID && timeInfoNotFound ? (
          <Card>
            <CardBody>
              <Typography variant="subtitle1" gutterBottom align="center">
                {intl.formatMessage({
                  id: "view.timeInfoEdit.timeInfoNotFound"
                })}{" "}
                <Link to="/admin/edit-timeInfo">
                  {intl.formatMessage({
                    id: "createNew"
                  })}
                </Link>
              </Typography>
            </CardBody>
          </Card>
        ) : (
          <GridContainer
            container
            spacing={24}
            direction="row"
            justify="center"
            alignItems="center"
          >
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="rose">
                    <TimeInfoIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle} color="primary">
                    {(timeInfoID ? "Update" : "Create") + " Time Information"}
                  </h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12}>
                      <CustomInput
                        labelText="Name"
                        id="name"
                        error={error["name"]}
                        formControlProps={{
                          required: mandatory["name"],
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.name,
                          onChange: this.handleTextChange("name")
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <CustomInput
                        labelText="Description"
                        id="description"
                        formControlProps={{
                          required: mandatory["description"],
                          fullWidth: true
                        }}
                        inputProps={{
                          multiline: true,
                          rows: 5,
                          value: this.state.description,
                          onChange: this.handleTextChange("description")
                        }}
                      />
                    </GridItem>
                    {!hideCategory && <GridItem xs={12}>
                      <TextField
                        id="category"
                        select
                        label="Category"
                        className={classes.textField}
                        value={this.state.category}
                        onChange={this.handleTextChange('category')}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        <option value=""></option>
                        {categories.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </TextField>
                    </GridItem>}
                    <GridItem xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.active}
                            value={this.state.active}
                            onChange={this.handleSwitchChange("active")}
                            color="primary"
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Active"
                      />
                    </GridItem>
                  </GridContainer>
                  <Button
                    color="primary"
                    disabled={!modified}
                    className={classes.updateProfileButton}
                    onClick={this.onSubmit}
                  >
                    {`${timeInfoID ? "Update" : "Save"} TimeInfo`}
                  </Button>
                  <Clearfix />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        )}
      </React.Fragment>
    );
  }
}
TimeInfoEditPage.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    timeInfo: state.timeInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    insertTimeInfo: bindActionCreators(insertTimeInfo, dispatch),
    updateTimeInfo: bindActionCreators(updateTimeInfo, dispatch),
    deleteTimeInfo: bindActionCreators(deleteTimeInfo, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withStyles(userProfileStyles)(withSnackbar(TimeInfoEditPage))));
